import {ref, computed} from 'vue'

export const sliderWidth = ref(180)
export const resetSliderWidth = () => {
    sliderWidth.value = 180
}
export const changeSliderWidth = () => {
    sliderWidth.value = sliderWidth.value === 0 ? 180 : 0
}

export const sliderStyle = computed(() => {
    return {
        'width': '180px',
        // 'right': `${sliderWidth.value}px`
        transform: `translateX(${180 - sliderWidth.value}px)`
    }
})

export const pageStyle = computed(() => {
    return {
        'width': `calc(100vw - ${sliderWidth.value}px)`,
    }
})

